import api from '@pray/shared/utils/api';

export type GetMarketingCampaignReadinessParams = {
  artistId: string;
  campaignId: string;
};

/**
 * The eight SuperFunnel go-live checks for one campaign (Stripe, funds, org giving, trial config,
 * lead campaign placement, the fee invariant, and the advisory terms note). Blocking checks are
 * what gate Activate.
 */
export const getMarketingCampaignReadiness = async ({ artistId, campaignId }: GetMarketingCampaignReadinessParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}/readiness`;
  const response = await api.executeGetRequest(url);

  return response.data;
};
